import React from "react";
import { PickersDay, Badge, Icon, useTheme } from "investira.react.components";

/**
 * Renderiza o componente ServerDay.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.highlightedDays - Propriedade `highlightedDays` do componente.
 * @param {*} props.posicoesAbertas - Propriedade `posicoesAbertas` do componente.
 * @param {*} props.custodianteConferencia - Propriedade `custodianteConferencia` do componente.
 * @param {*} props.onlyHighlightAble - Propriedade `onlyHighlightAble` do componente.
 * @param {*} props.day - Propriedade `day` do componente.
 * @param {*} props.outsideCurrentMonth - Propriedade `outsideCurrentMonth` do componente.
 * @param {*} props.other - Propriedade `other` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
function ServerDay(props) {
  const {
    highlightedDays = [],
    posicoesAbertas = [],
    custodianteConferencia = [],
    onlyHighlightAble = false,
    day,
    outsideCurrentMonth = false,
    ...other
  } = props;

  const theme = useTheme();
  const xColorWarning = theme.palette.warning.main;

  const xDay = day.format("DDMMYYYY");

  const isHighlighted =
    !outsideCurrentMonth && highlightedDays.indexOf(day.date()) >= 0;

    const xHasCustodiantePosicao = custodianteConferencia[xDay] ?? false;

  const xPickersDayProps = {
    ...other,
    outsideCurrentMonth,
    day,
    ...(xHasCustodiantePosicao && { sx: {
      border: `2px solid ${xColorWarning}`,
    } }),
    ...(onlyHighlightAble && { disabled: !isHighlighted }),
  };

  const xIsAberta = posicoesAbertas[xDay];

  return (
    <Badge
      key={props.day.toString()}
      color={"warning"}
      invisible={!isHighlighted}
      overlap="circular"
      variant={xIsAberta ? "standard" : "dot"}
      badgeContent={
        xIsAberta ? <Icon iconName="box_3d_open" size={12} /> : null
      }
      size={"small"}
    >
      <PickersDay {...xPickersDayProps} />
    </Badge>
  );
}

ServerDay.displayName = "ServerDay";

export default ServerDay;
